
var cookie = {
    set: function (name, value) {
        document.cookie = name + "=" + value;
    },
    get: function (name) {
        var value = "";
        var cookies = document.cookie;
        var arr = cookies.split(';')
        arr.forEach(element => {
            var arr2 = element.split('=');
            if (arr2[0].trim() === name) {
                value = arr2[1].trim();
                //break;
            }
        });
        return value;
    }
};
export default cookie; 


// WEBPACK FOOTER //
// ./src/func/Cookie.js